var _defs, _rect, _rect2, _rect3, _rect4, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveUpIkonFjarrkylaFlode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    "data-name": "Lager 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 768 766",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{font-size:134.07px;font-family:Barlow-Bold, Barlow;font-weight:700;letter-spacing:0.08em;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 247.89,
    y: 294.41,
    width: 270,
    height: 26.09,
    transform: "translate(765.77 614.91) rotate(-180)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 247.89,
    y: 294.41,
    width: 270,
    height: 26.09,
    transform: "translate(690.34 -75.43) rotate(90)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 247.89,
    y: 294.41,
    width: 270,
    height: 26.09,
    transform: "translate(871.03 254.11) rotate(135)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 247.89,
    y: 294.41,
    width: 270,
    height: 26.09,
    transform: "translate(329.55 -180.69) rotate(45)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(315.51 567.83)"
  }, "M3")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveUpIkonFjarrkylaFlode);
export default __webpack_public_path__ + "static/media/SaveUp_Ikon-fjarrkyla-flode.291a5f6292cfb1f7d1d161c71eba6267.svg";
export { ForwardRef as ReactComponent };